module.exports = __webpack_public_path__ + "static/media/btn_back.533af93c.svg";